import { useRequest } from 'ahooks';
import { getPdf } from '@axios/api';

function useGetPdf(){
    const {loading:getPdfLoading,data:getPdfData,runAsync:getPdfAction} = useRequest(
        async (params) => {
            try{
                const resp = await getPdf({...params});

                const fileName = params?.policy_info[0]?.policy_title;
                let fileNameWithSuffix = ''
                if (params?.policy_info?.length === 1) {
                    fileNameWithSuffix = `${fileName}.pdf`;
                } else if (params?.policy_info?.length > 1) {
                    fileNameWithSuffix = `政策文件.zip`;
                }

                const blob = new Blob([resp.data])
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileNameWithSuffix); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                return true;

            }catch(error){
                return false
            }
        },
        {
            debounceWait: 240,
            manual: true,
        }
    )

    return {
        getPdfLoading,
        getPdfData,
        getPdfAction
    }
}

export default useGetPdf